import { Component, Input } from '@angular/core';
import { MaterialModule } from 'src/app/material.module';

@Component({
  selector: 'app-loading-icon',
  imports: [MaterialModule],
  templateUrl: './loading-icon.component.html'
})
export class LoadingIconComponent {
  @Input() loading!: boolean
}
